import request from '../../utils/request';
import eventBus from '../../utils/fresh-table';
var reqData = {
    keyUrl: '/proxy/insClaim/statistics/createDownloadTask',
    keyMethod: 'post',
    statusUrl: '/proxy/insClaimPolling/statistics/queryDownloadTask',
    statusMethod: 'post',
    params: '',
    fileGiftKey: 'taskId',
};
function getKey() {
    // 获取文件key
    var keyUrl = reqData.keyUrl, keyMethod = reqData.keyMethod, params = reqData.params;
    request({
        url: keyUrl,
        method: keyMethod ? keyMethod : 'post',
        data: params,
    }).then(function (res) {
        if (!res || res.errorCode || !res.data)
            return;
        var key = res.data.id;
        exportPolling(key);
    });
}
function exportPolling(key) {
    // 轮询下载接口
    var pollingMain = function () {
        getExportStatus(key).then(function (res) {
            // (0 未使用 1:等待下载 2:正在下载 3:下载完成 4:下载失败
            if (!res || res.errorCode || !res.data || res.data.taskStatus === 4) {
                eventBus.$message.error('抱歉，下载失败了');
                return clearTimeout(timer);
            }
            if (res.data.taskStatus !== 3)
                return (timer = setTimeout(function () {
                    pollingMain();
                }, 500));
            location.href = res.data.fileUri;
            clearTimeout(timer);
        });
    };
    var timer = setTimeout(function () {
        pollingMain();
    }, 500);
}
function getExportStatus(key) {
    var _a;
    //下载主函数
    var statusUrl = reqData.statusUrl, statusMethod = reqData.statusMethod, fileGiftKey = reqData.fileGiftKey;
    return request({
        url: statusUrl,
        method: statusMethod ? statusMethod : 'post',
        data: (_a = {},
            _a[fileGiftKey || 'fileGiftKey'] = key,
            _a),
    });
}
function exportData(params) {
    reqData.params = params;
    reqData.keyUrl && getKey();
}
export { exportData };
